var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorePin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "24px",
    viewBox: "0 0 17 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "578D7ECC-9AEA-4729-AC7B-1ED255B78C27") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VIP-Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Typography",
    transform: "translate(-780.000000, -4168.000000)",
    fill: "#0B80E0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M788.5,4180 C786.567417,4180 785,4178.43258 785,4176.5 C785,4174.56742 786.567417,4173 788.5,4173 C790.433167,4173 792,4174.56742 792,4176.5 C792,4178.43258 790.433167,4180 788.5,4180 M788.5,4172 C786.014875,4172 784,4174.01487 784,4176.5 C784,4178.98513 786.014875,4181 788.5,4181 C790.985125,4181 793,4178.98513 793,4176.5 C793,4174.01487 790.985125,4172 788.5,4172 M788.5,4190 C788.5,4190 781,4183 781,4176.53846 C781,4172.37508 784.357857,4169 788.5,4169 C792.642143,4169 796,4172.37508 796,4176.53846 C796,4183 788.5,4190 788.5,4190 M788.5,4168 C783.805875,4168 780,4171.90764 780,4176.72727 C780,4183.81818 788.5,4192 788.5,4192 C788.5,4192 797,4183.81818 797,4176.72727 C797,4171.90764 793.194125,4168 788.5,4168",
    id: "address-icon"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorePin);
export default __webpack_public_path__ + "static/media/storePin.61a3ba03.svg";
export { ForwardRef as ReactComponent };